// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_0jL","cls2":"ActiveState-cls2_ohn ActiveState-cls1_0jL"};